// @Flow;
import React, { useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./styles.css";
import { Link } from "react-router-dom";
import Page from "../../components/page";
import TextBox from "../../components/text-box";
import TrashDrop from "../../models/trash-drop";
import { search } from "../../libs/utilities";
import queryString from "query-string";
import NumberBox from "../../components/number-box";
import Tags from "../../components/tags";
import { MetaData } from "../../components/meta-data";
import { Card } from "../../components/card";
import * as trashDropActionCreators from "../../action-creators/trash-drop-actions";
import moment from "moment";
import SearchBar from "../../components/search-bar";
import Layout from "../../components/layout";
import * as R from "ramda";

type RProps = { id: string, createdBy: Object, tags: Array<string>, bagCount: number, name: string, created: Date };


/**
 *
 * @param {string} key - state key
 * @param {object} value - value
 * @returns {void}
 * @private
 */
function _handleStateChange(key: string, value: string): void {
    this.setState({ [key]: value });
}


type PropsType = {
    panel: ?Object,
    data: Object,
    datum: ?TrashDrop,
    error: ?string,
    users: Object
};


const MyScreen = ({ actions, data, users, error, datum, panel }: PropsType) => {


    const [currentTrashDrop, setCurrentTrashDrop] = useState({});
    const [list, setList] = useState([]);

    const handleCurrentTrashDropChange = R.curry((key, value) => {
        setCurrentTrashDrop({ ...currentTrashDrop, [key]: value });
    });

    const RowTemplate = ({ id, createdBy, tags, bagCount, created }: RProps): React.Component => (
        <Link className={ "trash-drops--row" } to={ `/trash-drops/${id}${window.location.search}` }>
            <span className="trashDrop--time"><span>{moment(created).format("hh:mm MM/DD/YYYY")}</span></span>
            <span className="trashDrop--created-by"><span>{"Dropped By:"}</span><span>{(createdBy || {}).displayName || (createdBy || {}).email || ""}</span></span>
            <span className="trashDrop--bag-count"><span>{"Bags:"}</span><span>{bagCount || 0}</span></span>
            <span className="trashDrop--tags"><span>{"Tags:"}</span><span>{(tags || []).join(", ")}</span></span>
        </Link>
    );


    const headerContent = (
        <button className="teams--header-button" onClick={ () => {
            actions.saveTrashDrop(currentTrashDrop);
        } }>
            {"Save"}
        </button>
    );


    const q = queryString.parse(window.location.search);
    const filteredData = search(data, q.search);
    const createdBy = (((users || {}).data || {})[(currentTrashDrop.createdBy || {}).uid] || {}).displayName || "";
    return (

        <Page RowTemplate={ RowTemplate }
            data={ filteredData }
            headerContent={ headerContent }
            pagination={ false }
            toolbar={ (<SearchBar/>) }
        >
            <section className={ "trash-drops" }>
                <MetaData
                    created={ currentTrashDrop.created }
                    id={ currentTrashDrop.id }
                    updated={ currentTrashDrop.updated }
                />
                <Card>
                    <TextBox
                        labelText={ "CreatedBy" }
                        readOnly={ true }
                        value={ createdBy }/>
                    <NumberBox labelText={ "Bag Count" }
                        onChange={ (value) => handleCurrentTrashDropChange("bagCount")(parseInt(value, 10)) }
                        value={ currentTrashDrop.bagCount }/>
                    <Tags labelText={ "Tags" }
                        onChange={ handleCurrentTrashDropChange("tags") }
                        tags={ ["tires", "medical waste", "large object"] }
                        value={ (currentTrashDrop.tags) }
                    />
                </Card>
            </section>
        </Page>

    );
};

const mapStateToProps = (state: Object): Object => {
    const users = state.users;
    const data = Object.values((state.trashDrops || {}).data || {});
    return { users, data, currentPage: 1 };
};

const mapDispatchToProps = (dispatch): Object => ({
    actions: bindActionCreators(trashDropActionCreators, dispatch)
});

export const TrashDropsScreen = connect(mapStateToProps, mapDispatchToProps)(MyScreen);
